import React from 'react';
import { TitleSlide, BigIdeaSlide, EvolutionPyramidSlide, AttentionEconomySlide, HiddenIncentiveSlide } from '../slides/Slides1_5';
import { ConvergenceIntroSlide } from '../slides/ConvergenceIntroSlide';
import { BlockchainMarketsSlide } from '../slides/BlockchainMarketsSlide';
import { BlockchainEvolutionSlide } from '../slides/BlockchainEvolutionSlide';
import { ImpactEquationDetailedSlide } from '../slides/ImpactEquationDetailedSlide';
import { ImpactFlywheelDetailedSlide } from '../slides/ImpactFlywheelDetailedSlide';
import { ImpactStackDetailedSlide } from '../slides/ImpactStackDetailedSlide';
import { OracleAppsSlide } from '../slides/OracleAppsSlide';
import { ImpactParadoxSlide, BigQuestionSlide, BreakthroughSlide } from '../slides/Slides6_10';
import { SalesHeroSlide, SalesAwarenessSlide, SalesChallengeSlide, SalesSolutionSlide, SalesComparisonSlide } from '../slides/Sales16_20';
import { SalesNodeSlide, SalesDemandSlide, SalesRewardsSlide, SalesAppsSlide, SalesLoyaltySlide } from '../slides/Sales21_25';
import { SalesOutlookSlide, SalesEarlySlide, SalesPricingSlide, SalesAudienceSlide, SalesCtaSlide } from '../slides/Sales26_30';
import { SlideWrapper } from '../slides/SharedComponents';

const slideMap = {
  'title': TitleSlide,
  'convergence-intro': ConvergenceIntroSlide,
  'blockchain-markets': BlockchainMarketsSlide,
  'blockchain-evolution': BlockchainEvolutionSlide,
  'impact-equation-detailed': ImpactEquationDetailedSlide,
  'impact-flywheel-detailed': ImpactFlywheelDetailedSlide,
  'impact-stack-detailed': ImpactStackDetailedSlide,
  'oracle-apps': OracleAppsSlide,
  'big-idea': BigIdeaSlide,
  'evolution-pyramid': EvolutionPyramidSlide,
  'attention-economy': AttentionEconomySlide,
  'hidden-incentive': HiddenIncentiveSlide,
  'impact-paradox': ImpactParadoxSlide,
  'big-question': BigQuestionSlide,
  'breakthrough': BreakthroughSlide,
  'sales-hero': SalesHeroSlide,
  'sales-awareness': SalesAwarenessSlide,
  'sales-challenge': SalesChallengeSlide,
  'sales-solution': SalesSolutionSlide,
  'sales-comparison': SalesComparisonSlide,
  'sales-whatisnode': SalesNodeSlide,
  'sales-demand': SalesDemandSlide,
  'sales-rewards': SalesRewardsSlide,
  'sales-apps': SalesAppsSlide,
  'sales-loyalty': SalesLoyaltySlide,
  'sales-outlook': SalesOutlookSlide,
  'sales-early': SalesEarlySlide,
  'sales-pricing': SalesPricingSlide,
  'sales-audience': SalesAudienceSlide,
  'sales-cta': SalesCtaSlide,
};

const DefaultSlide = ({ slide }) => (
  <SlideWrapper slide={slide} background={
    <div className="fixed inset-0 z-0">
      <div className="absolute inset-0 bg-gradient-to-b from-[#030308] via-[#060610] to-[#030308]" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[600px] bg-[#0068ff] opacity-[0.06] blur-[180px] rounded-full" />
    </div>
  }>
    <div className="relative z-10 flex flex-col items-center justify-center h-full px-8">
      {slide.title && <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-center mb-6 animate-slide-up">{slide.title}</h2>}
      {slide.headline && <p className="text-xl text-white/50 text-center max-w-3xl animate-fade-in">{slide.headline}</p>}
    </div>
  </SlideWrapper>
);

const Slide = ({ slide, isActive }) => {
  if (!isActive) return null;
  const TypeComponent = slideMap[slide.type];
  if (TypeComponent) return <TypeComponent slide={slide} />;
  return <DefaultSlide slide={slide} />;
};

export default Slide;
